<template>
    <div class="p-2 row h-100">
        <div v-bind:class="fullWidth()">

            <b-tabs content-class="mt-3" v-model="tabIndex">
                <b-tab :title="$t('translations.subtitle_user_details')" href="#userDetails">

                    <h4 class='section-heading'>{{ $t('translations.subtitle_user_details')}} <span v-if='$parent.event == "staff"' class="small float-right">{{ $t('translations.see_settings_groups')}}</span></h4>

                    <div v-if="is_network_admin() && item && item.provider && item.provider.id" class="form-group d-flex border-bottom">
                        <div class="col-10">{{ $t('translations.provider')}}:</div><div class="col-14"> {{$root.lookup.providers[item.provider.id].name}}</div>
                    </div>

                    <div v-if="item.provider.user_role_id" class="form-group d-flex border-bottom">
                        <div class="col-10">{{ $t('translations.user_role')}}:</div><div class="col-14"> {{nameLookupById("user_roles", item.provider.user_role_id)}}</div>
                    </div>

                    <div v-if="item.user_title" class="form-group d-flex border-bottom">
                        <div class="col-10">{{ $t('translations.title')}}:</div><div class="col-14"> {{ $t('translations.'+item.user_title.name) }}</div>
                    </div>

                    <div class="form-group d-flex border-bottom">
                        <div class="col-10">{{ $t('translations.forename(s)')}}:</div><div class="col-14"> {{item.forenames}}</div>
                    </div>

                    <div class="form-group d-flex border-bottom">
                        <div class="col-10">{{ $t('translations.surname')}}:</div><div class="col-14"> {{item.surname}}</div>
                    </div>


                    <div class="form-group d-flex border-bottom" v-if="$parent.event == 'staff'">
                        <div class="col-10">{{ autobrand('translations.alias')}}:</div>
                        <div class="col-14"> {{ item.alias }}</div>
                    </div>

                    <div v-if='event == "patient"' class="form-group d-flex border-bottom">
                        <div class="col-10">{{ $t('translations.IDStatus')}}:</div>
                        <div class="col-14">{{ $t('translations.' + $root.lookup.verification_statuses[item.verification_status_id])}}</div>
                    </div>

                    <div class="form-group d-flex border-bottom">
                         <div class="col-10">{{ $t('translations.email')}}:</div><div class="col-14"> {{item.email}}</div>
                    </div>

                    <!-- <div class="form-group">
                        Provider: {{item.provider.name}}
                    </div> -->

                    <div v-if='event == "patient"' class="form-group d-flex border-bottom">
                        <div class="col-10">{{ $t('translations.DOB')}}:</div><div class="col-14"> {{item.dob | formatDate}}</div>
                    </div>

                    <div class="form-group d-flex border-bottom">
                        <div class="col-10">{{ $t('translations.gender')}}:</div><div class="col-14"> {{$t('translations.' + getGender(item.gender))}}</div>
                    </div>

                    <div v-if='event == "patient"' class="form-group d-flex border-bottom">
                        <div class="col-10">{{ $t('translations.usual_GP')}}:</div><div class="col-14" v-text='formatNameCompliant(item.provider.preferred_clinician)'></div>
                    </div>

                    <!-- <div v-if='event == "staff"' class="form-group d-flex border-bottom">
                        <div class="col-10">Preferred Site:</div><div class="col-14" v-text='getSiteName(item)'></div>
                    </div> -->

                    <div v-if='event == "patient"' class="form-group d-flex border-bottom">
                        <div class="col-10">{{ $t('translations.preferred_site')}}:</div><div class="col-14" v-text='getSiteName(item)'></div>
                    </div>

                    <div class="form-group d-flex border-bottom">
                        <div class="col-10">{{ $t('translations.telephone_number')}}:</div><div class="col-14"> {{item.phone_number}}</div>
                    </div>

                    <div v-if='event == "patient"' class="form-group d-flex border-bottom">
                        <div class="col-10">{{ $t('translations.alternative_telephone')}}:</div><div class="col-14"> {{item.phone_number_alt}}</div>
                    </div>

        <!-- if more than one site -->
                    <!-- <div v-if='event == "patient"' class="form-group row">
                        <div class="col-md-6">Preferred Location:</div><div class="col-md-16"> {{item.site_id}}</div>
                    </div> -->

                    <template v-if='event == "patient"'>
                        <div class="form-group d-flex border-bottom">
                            <div class="col-10">{{ $t('translations.NHS_number')}}:</div><div class="col-14" v-if="item.nhs_number"> {{item.nhs_number.replace(/(.{3})/,"$1&nbsp;").replace(/(.{7})/,"$1&nbsp;")}}</div>
                        </div>

                        <!-- <div v-if="item.verification_status" class="form-group row">
                            <div class="col-md-6">ID Status:</div><div class="col-md-16"> {{item.verification_status.name}}</div>
                        </div> -->
                    </template>

                    <div v-if='event == "patient"' class="form-group d-flex border-bottom">
                         <div class="col-10">{{ $t('translations.address_line_1')}}:</div><div class="col-14"> {{item.address_line_1}}</div>
                    </div>

                    <div v-if='event == "patient"' class="form-group d-flex border-bottom">
                         <div class="col-10">{{ $t('translations.address_line_2')}}:</div><div class="col-14"> {{item.address_line_2}}</div>
                    </div>

                    <div v-if='event == "patient"' class="form-group d-flex border-bottom">
                         <div class="col-10">{{ $t('translations.address_line_3')}}:</div><div class="col-14"> {{item.address_line_3}}</div>
                    </div>

                    <div v-if='event == "patient"' class="form-group d-flex border-bottom">
                         <div class="col-10">{{ $t('translations.address_line_4')}}:</div><div class="col-14"> {{item.address_line_4}}</div>
                    </div>

                    <div v-if='event == "patient"' class="form-group d-flex border-bottom">
                         <div class="col-10">{{ $t('translations.postcode')}}:</div><div class="col-14 text-uppercase"> {{item.postcode}}</div>
                    </div>

                    <div v-if='event == "staff"' class="form-group d-flex border-bottom">
                        <div class="col-10">{{ $t('translations.profession')}}:</div><div class="col-14"> {{item.profession}}</div>
                    </div>

                    <div v-if='event == "staff"' class="form-group d-flex border-bottom">
                        <div class="col-10">{{ $t('translations.gpad_profession')}}:</div><div v-if='$root.lookup.relatedData[$root.apiBase + "/staff"]' class="col-14"> {{ nameLookupById($root.lookup.relatedData[$root.apiBase + "/staff"].professions, item.profession_id)}}</div>
                    </div>

                    <div v-if='event == "staff" && mrs_enabled()' class="form-group d-flex border-bottom">
                        <div class="col-10">{{ $t('translations.mrs_user_id')}}:</div><div class="col-14"> {{ item.provider.mrs_user_id }}</div>
                    </div>

                    <div class="form-group d-flex border-bottom">
                        <div class="col-10">{{ $t('translations.language')}}:</div><div class="col-14"> {{item.locale}}</div>
                    </div>

                </b-tab>

                <b-tab :title="this.$t('translations.weekly_rota')" v-if='$parent.event == "staff"'  href="#rota">

                    <template v-if='$parent.item.availability_date'>
                        <h4 class='section-heading'>{{ $t('translations.weekly_rota')}}</h4>
                        <div v-if="$parent.item.availability_date" class="pb-2 form-group">
                            <table class='availability table'>
                                <thead class="thead-light">
                                    <tr>
                                        <th>{{ $t('translations.day_of_week')}}</th>
                                        <th>{{ $t('translations.availability')}}</th>
                                        <th>{{ $t('translations.site')}}</th>
                                        <th>{{ autobrand('translations.capacity_requests')}}</th>
                                    </tr>
                                </thead>

                                <template v-for="(day, day_of_week) in $root.lookup.dayNames">
                                
                                    <tr :key='day_of_week' class='day_heading'>
                                        <td :colspan='4'>{{ day | capitalise}}</td>
                                    </tr>
                                    <template v-if='getAvailabilityIndexes($parent.item.availability_date, day_of_week).length'>
                                        <template v-for='(date_index) in getAvailabilityIndexes($parent.item.availability_date, day_of_week)'>
                                            <template v-if='$parent.item.availability_date[date_index].availability_time.filter(obj => {return $root.provider.site.find(site => {return (is_network_admin() || site.id == obj.site_id)})}).length'>
                                                <template v-for='(time, index) in $parent.item.availability_date[date_index].availability_time'>
                                                    <tr v-if='is_network_admin() || $root.provider.site.find(site => {return site.id == time.site_id})' :key='$parent.item.availability_date[date_index].id + "-" + index' class='day_value'>
                                                        <td>&nbsp;</td>
                                                        <td :key='"time-" + $parent.item.availability_date[date_index].id + "-" + index'>
                                                            <ul>
                                                                <li :key='$parent.item.availability_date[date_index].id + "-" + index'>
                                                                    {{getTimeRange(time) | capitalise}}
                                                                </li>
                                                            </ul>
                                                        </td>
                                                        <td :key='"site-" + $parent.item.availability_date[date_index].id + "-" + index'>
                                                            {{ getSiteNameById(time.site_id, sites) }}
                                                        </td>
                                                        <td :key='"capacity-" + $parent.item.availability_date[date_index].id + "-" + index'>
                                                            {{time.capacity}}
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <tr :key='$parent.item.availability_date[date_index].id + "-none"'>
                                                    <td colspan='4'>{{ $t('translations.no_availability')}}</td>
                                                </tr>
                                            </template>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <tr :key='day + "-none"'>
                                            <td colspan='4'>{{ $t('translations.no_availability')}}</td>
                                        </tr>
                                    </template>
                                </template>
                            </table>
                        </div>
                        <p v-else>
                            {{ $t('translations.no_standard_availability')}}.
                        </p>

                        <h4 class='section-heading'>{{ $t('translations.availability_exceptions')}}</h4>
                        <div class="pb-2 form-group">
                            <table class='availability table'>
                                <thead class="thead-light">
                                    <tr>
                                        <th>{{ $t('translations.date')}}</th>
                                        <th>{{ $t('translations.availability')}}</th>
                                        <th>{{ $t('translations.site')}}</th>
                                        <th>{{ autobrand('translations.capacity_requests')}}</th>
                                    </tr>
                                </thead>
                                <template v-if='getAvailabilityExceptionIndexes($parent.item.availability_date).length'>
                                    <template v-for='(date_index) in getAvailabilityExceptionIndexes($parent.item.availability_date)'>
                                        <tr v-if='$parent.item.availability_date[date_index].availability_time.filter(obj => {return $root.provider.site.find(site => {return (is_network_admin() || site.id == obj.site_id)})}).length' :key='$parent.item.availability_date[date_index].id + "-" + date_index' class='day_value'>
                                            <td>
                                                {{ getDateRange($parent.item.availability_date[date_index]) | capitalise}}
                                            </td>
                                            <td>
                                                <template v-for='(time, index) in $parent.item.availability_date[date_index].availability_time'>
                                                    {{getTimeRange($parent.item.availability_date[date_index].availability_time[index]) | capitalise}}
                                                </template>
                                            </td>
                                            <td>
                                                {{ getSiteNameById($parent.item.availability_date[date_index].availability_time[0].site_id, sites) }}
                                            </td>
                                            <td>
                                                {{$parent.item.availability_date[date_index].availability_time[0].capacity}}
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                                <template v-else>
                                    <tr :key='"exceptions-none"'>
                                        <td colspan='4'>{{$t('translations.no_availibility_exceptions_found')}}</td>
                                    </tr>
                                </template>
                            </table>
                        </div>
                    </template>

                </b-tab>

                <b-tab v-if='appointmentsEnabled() && $parent.event == "staff"' :title="$t('translations.appointment_settings')"  href="#appointments">

                    <h4 class='section-heading'>{{ $t('translations.appointment_session_types')}}</h4>

                    <appointment-session-type-table  
                        v-model='$parent.item.appointment_session_type' />
                    
                    <hr>

                    <h4 class='section-heading'>{{ $t('translations.appointment_sessions') }}</h4>
                    <!-- <router-link to="/appointments" class="btn btn-icon-left btn-round btn-primary float-right"><span class="icon icon-calendar"></span>{{ $t('translations.buttonViewAppointmentsCalendar') }}</router-link> -->
                    <appointment-session-table  
                        v-model='$parent.item.appointment_session' 
                        :appointment_session_type='$parent.item.appointment_session_type'/>
                    

                </b-tab>

                 <b-tab v-if='$parent.item && $parent.event == "staff"' :title="$t('translations.user_groups')" href="#userGroups">

                    <h4 class='section-heading' id="userDetails">{{$t('translations.user_groups')}}</h4>
                    <ul v-if='item.user_group'>
                        <template v-for='user_group in sortByValue(lookup_user_groups, "name")'>
                            <li :key='user_group.id' v-if='item.user_group.find(obj => {return user_group.id == obj.user_group.id})'>
                                {{user_group.name}}
                            </li>
                        </template>
                    </ul>
                    <div v-if='!item.user_group || !item.user_group.length'>
                        <p>{{$t('translations.user_not_assigned_to_any_groups')}}</p>
                    </div>
                    
                </b-tab>
            </b-tabs>
        </div>

        <template v-if='event == "patient"'>
            <div class="col-md-10 d-flex flex-column h-100">
                <h4 class='section-heading'>{{ tBrand('is_proxy_for') }}:</h4>
                <template v-if='item.carees && item.carees.length > 0'>
                    <ul class="list-group flex-grow-1-scroll h-50">
                        <li class="list-group-item" v-for='relationship in item.carees'><a href="" v-on:click.prevent='$parent.$parent.openView($event, relationship.relation_id)'>{{formatNameCompliant(relationship)}} ({{$root.lookup.user_relationship_types[relationship.user_relationship_type_id]}})</a></li>
                    </ul>
                </template>
                <p v-else>{{ $t('translations.none_listed')}}</p>
                <!-- <button class="btn btn-
                primary" v-on:click.prevent='openAddRelationship' role="button">Add Relationship</button> -->

                <h4 class='section-heading'>{{ $t('translations.in_care_of')}}:</h4>
                <template v-if='item.carers && item.carers.length > 0'>
                    <ul class="list-group flex-grow-1-scroll h-50">
                        <li class="list-group-item" v-for='relationship in item.carers'><a href="" v-on:click.prevent='$parent.$parent.openView($event, relationship.user_id)'>{{formatNameCompliant(relationship)}} ({{$root.lookup.user_relationship_types[relationship.user_relationship_type_id]}})</a></li>
                    </ul>
                </template>
                <p v-else>{{ $t('translations.none_listed')}}</p>

                <h4 class='section-heading'>{{ $t('translations.tags') | capitalise }}:</h4>
                <template v-if='item.user_tag && item.user_tag.length > 0'>
                    <div>
                        <div :key='tag.tag_id' v-for='(tag) in item.user_tag' class='search-lozenge badge badge-primary badge-pill' :style="{'background-color': getTag(tag.tag_id).colour}">
                            <i :class='"pr-1 fa fa-lg fa-" + getTag(tag.tag_id).icon' /> {{ getTag(tag.tag_id).name }}
                        </div>
                    </div>        
                </template>
                <p v-else>{{ $t('translations.none_listed')}}</p>



                <h4 class='section-heading'>{{ autobrand('translations.previous_requests')}}</h4>
                <related-thread-list
                    v-if = 'item'
                    modalid="related-thread-filter-modal"
                    displayelement = "thread-list"
                    event = "thread"
                    model =  "thread"
                    title = "Requests"
                    path = 'threads'
                    route = '/api/v1/threads'
                    :user = 'item'>
                </related-thread-list>
            </div>
        </template>

    </div>
</template>

<script>
	export default {
        props: [
            'item',
            'event'
        ],

        data() {
            return {
                sites: [],
                tabIndex: 0,
                tabs: ['#userDetails', '#rota', '#appointments', '#userGroups'],
                lookup_user_groups: []
            }
        },
        watch: {
            item() {
                this.sites = this.getSitesFromUser(this.item);
                if(this.is_network_admin()) {
                    this.lookup_user_groups = []
                    this.$parent.item.user_provider.forEach(item => {
                        item.user_group.forEach(group => {
                            group.name = item.name + ": " + group.name;
                            this.lookup_user_groups.push(group);
                        });
                        //this.lookup_user_groups = this.lookup_user_groups.concat(item.user_group);
                    });
                }
                else {
                    this.lookup_user_groups = this.$root.lookup.user_groups;
                }
            }
        },
        mounted() {
            this.tabIndex = this.tabs.findIndex(tab => tab === this.$route.hash)
        },
        methods: {
            openAddRelationship() {

            },
            getName() {
                if(this.item.surname) {
                    return this.item.surname + ", " + this.item.forenames;
                }
                return "";
            },
            getTimeRange(time) {
                if(time.from) {
                    return this.formatShortTime(time.from) + " - " + this.formatShortTime(time.to);
                }
                else {
                    return this.$t('translations.unavailable');
                }
            },
            getDateRange(obj) {
                var date_spec = this.formatDate(obj.date_from);
                if(obj.date_to) {
                    date_spec += " - " + this.formatDate(obj.date_to);
                }
                return date_spec;
            },
            fullWidth() {
                if(this.event == 'patient') {
                    return 'col-14';
                } else {
                    return 'col-20';
                }
            },
            mrs_enabled() {
                if(this.is_network_admin()) {
                    return false;
                }
                else {
                    return this.$root.provider.record_system_integration_type_id;
                }
            }
        }
    };
</script>
